<template>
    <div>
        <ecard/>
    </div>
</template>

<script>
    import Ecard from "../components/contactus/ecard";
    export default {
        name: "ContactUs",
        components: {Ecard}
    }
</script>

<style scoped>

</style>